import { render, staticRenderFns } from "./OurFormations.vue?vue&type=template&id=531ce608"
import script from "./OurFormations.vue?vue&type=script&lang=js"
export * from "./OurFormations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports